import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Checkbox, NavHeader, Page, SubmitButton } from '../../components';
import { PinInput } from '../../components/pin-input/pin-input';
import { DEMO } from '../../const';
import { useBackdropContext } from '../../context/backdrop';
import { ROUTES } from '../../routes/routes';

type DemoFormData = {
  demoPushNotifications: boolean;
  ecoPoints: boolean;
  tariffComparator: boolean;
  dashboardDemo: boolean;
  ekoOzeDashboardDemo: boolean;
  weatherDashboardDemo: boolean;
};

const Demo: React.FC = () => {
  const { turnOnBackdrop, turnOffBackdrop } = useBackdropContext();
  const [pin, setPin] = useState<string>('');
  const {
    control,
    handleSubmit,
    formState: { isDirty, isValid },
  } = useForm<DemoFormData>({
    defaultValues: {
      demoPushNotifications: !!localStorage.getItem('demoPushNotifications'),
      ecoPoints: !!localStorage.getItem('ecoPoints'),
      tariffComparator: !!localStorage.getItem('tariffComparator'),
      ekoOzeDashboardDemo: !!localStorage.getItem('ekoOzeDashboardDemo'),
      weatherDashboardDemo: !!localStorage.getItem('weatherDashboardDemo'),
    },
  });

  const renderCheckbox = (name: keyof DemoFormData, title: string) => (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <Checkbox checked={value} reverse onChange={(e) => onChange(e.target.checked)}>
          <p>{title}</p>
        </Checkbox>
      )}
    />
  );

  const onSubmit = (data: DemoFormData) => {
    turnOnBackdrop();

    Object.entries(data).forEach(([property, checked]) => {
      if (checked) localStorage.setItem(property, 'true');
      else localStorage.removeItem(property);
    });

    setTimeout(() => {
      turnOffBackdrop();
      window.location.href = ROUTES.Root();
    }, 1000);
  };

  return (
    <Page isStickyHeader header={<NavHeader title="Demo" />}>
      <>
        {pin !== DEMO ? (
          <PinInput pin={pin} onChange={setPin} />
        ) : (
          <form onSubmit={handleSubmit(onSubmit)}>
            {renderCheckbox('demoPushNotifications', 'Demo push')}
            {renderCheckbox('ecoPoints', 'Grywalizacja (punkty)')}
            {renderCheckbox('tariffComparator', 'Porównywarka taryf')}
            {renderCheckbox('ekoOzeDashboardDemo', 'Dashboard: sekcja Eko OZE')}
            {renderCheckbox('weatherDashboardDemo', 'Dashboard: Poradnik pogodowy')}
            <SubmitButton type="submit" disabled={!isDirty || !isValid} />
          </form>
        )}
      </>
    </Page>
  );
};

export default Demo;
